export default __webpack_public_path__ + "static/media/IconDesc_Computer.256.1728a0ec.png";